import { defineMessages } from 'react-intl';

const messages = defineMessages({
  backLink: {
    id: 'hs-update-form.back-link',
    defaultMessage: 'Back to My Institution',
  },
  changeLogo: {
    id: 'hs-update-form.change-logo',
    defaultMessage: 'Change Logo',
  },
  contactInfo: {
    id: 'hs-update-form.contact-info',
    defaultMessage: 'CONTACT INFORMATION',
  },
  address: {
    id: 'hs-update-form.address',
    defaultMessage: 'Address',
  },
  city: {
    id: 'hs-update-form.city',
    defaultMessage: 'City',
  },
  state: {
    id: 'hs-update-form.state',
    defaultMessage: 'State',
  },
  zip: {
    id: 'hs-update-form.zip',
    defaultMessage: 'Zip',
  },
  county: {
    id: 'hs-update-form.county',
    defaultMessage: 'County',
  },
  country: {
    id: 'hs-update-form.country',
    defaultMessage: 'Country',
  },
  phone: {
    id: 'hs-update-form.phone',
    defaultMessage: 'Phone',
  },
  phonePlaceholder: {
    id: 'hs-update-form.phone.placeholder',
    defaultMessage: 'Ex: (555) 555-5555',
  },
  fax: {
    id: 'hs-update-form.fax',
    defaultMessage: 'Fax',
  },
  faxPlaceholder: {
    id: 'hs-update-form.fax.placeholder',
    defaultMessage: 'Ex: (555) 555-5555',
  },
  websiteUrl: {
    id: 'hs-update-form.website-url',
    defaultMessage: 'Website URL',
  },
  websiteUrlPlaceholder: {
    id: 'hs-update-form.website-url.placeholder',
    defaultMessage: 'Ex: www.yourschool.edu',
  },
  enrollment: {
    id: 'hs-update-form.enrollment',
    defaultMessage: 'ENROLLMENT DATA',
  },
  enrollmentGender: {
    id: 'hs-update-form.enrollment.by-gender',
    defaultMessage: 'Enrollment by gender',
  },
  male: {
    id: 'hs-update-form.enrollment.by-gender.male',
    defaultMessage: 'Male',
  },
  female: {
    id: 'hs-update-form.enrollment.by-gender.female',
    defaultMessage: 'Female',
  },
  nonbinary: {
    id: 'hs-update-form.enrollment.by-gender.nonbinary',
    defaultMessage: 'Nonbinary',
  },
  enrollmentRace: {
    id: 'hs-update-form.enrollment.by-race',
    defaultMessage: 'Enrollment by race/ethnicity',
  },
  asianpacificisl: {
    id: 'hs-update-form.enrollment.by-race.asianpacificisl',
    defaultMessage: 'Asian or Asian/Pacific Islander',
  },
  amIndAlasNat: {
    id: 'hs-update-form.enrollment.by-race.am-ind-alas-nat',
    defaultMessage: 'American Indian/Alaska Native',
  },
  hawaiNatpcfIsl: {
    id: 'hs-update-form.enrollment.by-race.hawai-natpcfisl',
    defaultMessage: 'Hawaiian Native/Pacific Islander',
  },
  blackAfrican: {
    id: 'hs-update-form.enrollment.by-race.black-african',
    defaultMessage: 'Black/African American',
  },
  white: {
    id: 'hs-update-form.enrollment.by-race.white',
    defaultMessage: 'White',
  },
  hispanic: {
    id: 'hs-update-form.enrollment.by-race.hispanic',
    defaultMessage: 'Hispanic or Latino',
  },
  twoormoreRaces: {
    id: 'hs-update-form.enrollment.by-race.twoormore-races',
    defaultMessage: 'Two or More Races',
  },
  enrollmentGrade: {
    id: 'hs-update-form.enrollment.by-grade',
    defaultMessage: 'Enrollment by grade',
  },
  preKindergartenStud: {
    id: 'hs-update-form.enrollment.by-grade.prekindergarten',
    defaultMessage: 'Prekindergarten Students',
  },
  kindergartenStud: {
    id: 'hs-update-form.enrollment.by-grade.kindergarten',
    defaultMessage: 'Kindergarten Students',
  },
  gradeStudents: {
    id: 'hs-update-form.enrollment.by-grade.grade-stud',
    defaultMessage: 'Grade {grade}',
  },
  titleInformation: {
    id: 'hs-update-form.title-information',
    defaultMessage: 'Title I Information',
  },
  titleEligible: {
    id: 'hs-update-form.title-eligible',
    defaultMessage: 'Title I Eligible',
  },
  titleStatus: {
    id: 'hs-update-form.title-status',
    defaultMessage: 'Title I Status',
  },
  none: {
    id: 'hs-update-form.none',
    defaultMessage: 'None',
  },
  unknown: {
    id: 'hs-update-form.unknown',
    defaultMessage: 'Unknown',
  },
  tasNo: {
    id: 'hs-update-form.status.tasNo',
    defaultMessage: 'Eligible for Title I TAS provides no program.',
  },
  tasTas: {
    id: 'hs-update-form.status.tasTas',
    defaultMessage: 'Eligible for Title I TAS provides TAS program.',
  },
  swpTas: {
    id: 'hs-update-form.status.swpTas',
    defaultMessage: 'Eligible for Title I SWP provides TAS program.',
  },
  swpNo: {
    id: 'hs-update-form.status.swpNo',
    defaultMessage: 'Eligible for Title I SWP provides no program.',
  },
  swpSwp: {
    id: 'hs-update-form.status.swpSwp',
    defaultMessage: 'Eligible for Title I SWP provides SWP program.',
  },
  noTasNoSwp: {
    id: 'hs-update-form.status.noTasNoSwp',
    defaultMessage: 'Not eligible for either TAS or SWP.',
  },
  academicData: {
    id: 'hs-update-form.academic-data',
    defaultMessage: 'ACADEMIC DATA',
  },
  charterSchool: {
    id: 'hs-update-form.academic-data.charter-school',
    defaultMessage: 'Charter School',
  },
  coeducational: {
    id: 'hs-update-form.academic-data.coeducational',
    defaultMessage: 'Coeducational',
  },
  coedOption: {
    id: 'hs-update-form.academic-data.coed.option',
    defaultMessage: 'Coed (school has male and female students)',
  },
  allMaleOption: {
    id: 'hs-update-form.academic-data.all-male.option',
    defaultMessage: 'All-male (school only has all-male students)',
  },
  allFemaleOption: {
    id: 'hs-update-form.academic-data.all-female.option',
    defaultMessage: 'All-female (school only has all-female students)',
  },
  collegeRate: {
    id: 'hs-update-form.academic-data.college-rate',
    defaultMessage: 'College-Going Rate',
  },
  collegeRatePlaceholder: {
    id: 'hs-update-form.academic-data.college-rate.placeholder',
    defaultMessage: 'Ex: 78%',
  },
  ratio: {
    id: 'hs-update-form.academic-data.student-teacher-ratio',
    defaultMessage: 'Student/Teacher ratio',
  },
  ratioPlaceholder: {
    id: 'hs-update-form.academic-data.student-teacher-ratio.placeholder',
    defaultMessage: 'Ex: 12 (for 12:1)',
  },
  fullTime: {
    id: 'hs-update-form.academic-data.full-time-teachers',
    defaultMessage: 'Full Time Teachers',
  },
  highestGrade: {
    id: 'hs-update-form.academic-data.highest-grade',
    defaultMessage: 'Highest Grade',
  },
  lowestGrade: {
    id: 'hs-update-form.academic-data.lowest-grade',
    defaultMessage: 'Lowest Grade',
  },
  ungraded: {
    id: 'hs-update-form.academic-data.grade.ungraded',
    defaultMessage: 'Ungraded',
  },
  prekindergarten: {
    id: 'hs-update-form.academic-data.grade.prekindergarten',
    defaultMessage: 'Prekindergarten',
  },
  kindergarten: {
    id: 'hs-update-form.academic-data.grade.kindergarten',
    defaultMessage: 'Kindergarten',
  },
  grade: {
    id: 'hs-update-form.academic-data.grade',
    defaultMessage: '{grade} Grade',
  },
  schoolLevel: {
    id: 'hs-update-form.academic-data.school',
    defaultMessage: 'School Level',
  },
  elementary: {
    id: 'hs-update-form.academic-data.level-options.elementary',
    defaultMessage: 'Elementary (K-6)',
  },
  secondary: {
    id: 'hs-update-form.academic-data.level-options.secondary',
    defaultMessage: 'Secondary (7-12)',
  },
  combined: {
    id: 'hs-update-form.academic-data.level-options.combined',
    defaultMessage: 'Combined (k-12)',
  },
  schoolType: {
    id: 'hs-update-form.academic-data.school-type',
    defaultMessage: 'School Type',
  },
  public: {
    id: 'hs-update-form.academic-data.school-type.public',
    defaultMessage: 'Public',
  },
  private: {
    id: 'hs-update-form.academic-data.school-type.private',
    defaultMessage: 'Private',
  },
  schoolTypeOptions: {
    id: 'hs-update-form.academic-data.type-options',
    defaultMessage: 'School Type Options',
  },
  schoolLastData: {
    id: 'hs-update-form.academic-data.school-last-data',
    defaultMessage: 'School Year of Last Reported Data',
  },
  save: {
    id: 'hs-update-form.save',
    defaultMessage: 'SAVE',
  },
  yes: {
    id: 'hs-update-form.yes',
    defaultMessage: 'Yes',
  },
  no: {
    id: 'hs-update-form.no',
    defaultMessage: 'No',
  },
  total: {
    id: 'hs-update-form.total',
    defaultMessage: 'Total',
  },
  numberStudents: {
    id: 'hs-update-form.number-students',
    defaultMessage: 'Number of students',
  },
  percentageStudents: {
    id: 'hs-update-form.percentage-students',
    defaultMessage: '% of Students',
  },
  studentsTeacher: {
    id: 'hs-update-form.students-teacher',
    defaultMessage: 'Students:Teacher',
  },
  numberTeachers: {
    id: 'hs-update-form.number-teachers',
    defaultMessage: 'Number of Teachers',
  },
  pubRegular: {
    id: 'hs-update-form.academic-data.school-type.pub-regular',
    defaultMessage: 'Regular school',
  },
  pubSpecial: {
    id: 'hs-update-form.academic-data.school-type.pub-special',
    defaultMessage: 'Special education school',
  },
  pubVocational: {
    id: 'hs-update-form.academic-data.school-type.pub-vocational',
    defaultMessage: 'Vocational school',
  },
  pubAlternative: {
    id: 'hs-update-form.academic-data.school-type.pub-alternative',
    defaultMessage: 'Alternative/other school',
  },
  privRegular: {
    id: 'hs-update-form.academic-data.school-type.priv-regular',
    defaultMessage: 'Regular Elementary or Secondary',
  },
  privMontessori: {
    id: 'hs-update-form.academic-data.school-type.priv-montessori',
    defaultMessage: 'Montessori',
  },
  privSpecialProgram: {
    id: 'hs-update-form.academic-data.school-type.priv-special-program',
    defaultMessage: 'Special Program Emphasis',
  },
  privSpecialEducation: {
    id: 'hs-update-form.academic-data.school-type.priv-special-education',
    defaultMessage: 'Special Education',
  },
  privCarTecVoc: {
    id: 'hs-update-form.academic-data.school-type.priv-car-tec-voc',
    defaultMessage: 'Career/Technical/Vocational',
  },
  privAlternative: {
    id: 'hs-update-form.academic-data.school-type.priv-alternative',
    defaultMessage: 'Alternative/Other',
  },
  privEarly: {
    id: 'hs-update-form.academic-data.school-type.priv-early',
    defaultMessage: 'Early Childhood Program/Child care center',
  },
  na: {
    id: 'hs-update-form.na',
    defaultMessage: 'Not specified',
  },
  updateError: {
    id: 'hs-update-form.error',
    defaultMessage: 'Unable to update',
  },
  AFGHANISTAN: {
    id: 'hs-update-form.academic-data.school-type.AFGHANISTAN',
    defaultMessage: 'Afghanistan',
  },
  ALAND_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.ALAND_ISLANDS',
    defaultMessage: 'Aland Islands',
  },
  ALBANIA: {
    id: 'hs-update-form.academic-data.school-type.ALBANIA',
    defaultMessage: 'Albania',
  },
  ALGERIA: {
    id: 'hs-update-form.academic-data.school-type.ALGERIA',
    defaultMessage: 'Algeria',
  },
  AMERICAN_SAMOA: {
    id: 'hs-update-form.academic-data.school-type.AMERICAN_SAMOA',
    defaultMessage: 'American Samoa',
  },
  ANDORRA: {
    id: 'hs-update-form.academic-data.school-type.ANDORRA',
    defaultMessage: 'Andorra',
  },
  ANGOLA: {
    id: 'hs-update-form.academic-data.school-type.ANGOLA',
    defaultMessage: 'Angola',
  },
  ANGUILLA: {
    id: 'hs-update-form.academic-data.school-type.ANGUILLA',
    defaultMessage: 'Anguilla',
  },
  ANTARCTICA: {
    id: 'hs-update-form.academic-data.school-type.ANTARCTICA',
    defaultMessage: 'Antarctica',
  },
  ANTIGUA_AND_BARBUDA: {
    id: 'hs-update-form.academic-data.school-type.ANTIGUA_AND_BARBUDA',
    defaultMessage: 'Antigua And Barbuda',
  },
  ARGENTINA: {
    id: 'hs-update-form.academic-data.school-type.ARGENTINA',
    defaultMessage: 'Argentina',
  },
  ARMENIA: {
    id: 'hs-update-form.academic-data.school-type.ARMENIA',
    defaultMessage: 'Armenia',
  },
  ARUBA: {
    id: 'hs-update-form.academic-data.school-type.ARUBA',
    defaultMessage: 'Aruba',
  },
  ASCENSION_ISLAND: {
    id: 'hs-update-form.academic-data.school-type.ASCENSION_ISLAND',
    defaultMessage: 'Ascension Island',
  },
  AUSTRALIA: {
    id: 'hs-update-form.academic-data.school-type.AUSTRALIA',
    defaultMessage: 'Australia',
  },
  AUSTRIA: {
    id: 'hs-update-form.academic-data.school-type.AUSTRIA',
    defaultMessage: 'Austria',
  },
  AZERBAIJAN: {
    id: 'hs-update-form.academic-data.school-type.AZERBAIJAN',
    defaultMessage: 'Azerbaijan',
  },
  BAHAMAS: {
    id: 'hs-update-form.academic-data.school-type.BAHAMAS',
    defaultMessage: 'Bahamas',
  },
  BAHRAIN: {
    id: 'hs-update-form.academic-data.school-type.BAHRAIN',
    defaultMessage: 'Bahrain',
  },
  BANGLADESH: {
    id: 'hs-update-form.academic-data.school-type.BANGLADESH',
    defaultMessage: 'Bangladesh',
  },
  BARBADOS: {
    id: 'hs-update-form.academic-data.school-type.BARBADOS',
    defaultMessage: 'Barbados',
  },
  BELARUS: {
    id: 'hs-update-form.academic-data.school-type.BELARUS',
    defaultMessage: 'Belarus',
  },
  BELGIUM: {
    id: 'hs-update-form.academic-data.school-type.BELGIUM',
    defaultMessage: 'Belgium',
  },
  BELIZE: {
    id: 'hs-update-form.academic-data.school-type.BELIZE',
    defaultMessage: 'Belize',
  },
  BENIN: {
    id: 'hs-update-form.academic-data.school-type.BENIN',
    defaultMessage: 'Benin',
  },
  BERMUDA: {
    id: 'hs-update-form.academic-data.school-type.BERMUDA',
    defaultMessage: 'Bermuda',
  },
  BHUTAN: {
    id: 'hs-update-form.academic-data.school-type.BHUTAN',
    defaultMessage: 'Bhutan',
  },
  BOLIVIA: {
    id: 'hs-update-form.academic-data.school-type.BOLIVIA',
    defaultMessage: 'Bolivia',
  },
  BOSNIA_AND_HERZEGOVINA: {
    id: 'hs-update-form.academic-data.school-type.BOSNIA_AND_HERZEGOVINA',
    defaultMessage: 'Bosnia And Herzegovina',
  },
  BOTSWANA: {
    id: 'hs-update-form.academic-data.school-type.BOTSWANA',
    defaultMessage: 'Botswana',
  },
  BOUVET_ISLAND: {
    id: 'hs-update-form.academic-data.school-type.BOUVET_ISLAND',
    defaultMessage: 'Bouvet Island',
  },
  BRAZIL: {
    id: 'hs-update-form.academic-data.school-type.BRAZIL',
    defaultMessage: 'Brazil',
  },
  BRITISH_INDIAN_OCEAN_TERRITORY: {
    id: 'hs-update-form.academic-data.school-type.BRITISH_INDIAN_OCEAN_TERRITORY',
    defaultMessage: 'British Indian Ocean Territory',
  },
  BRUNEI_DARUSSALAM: {
    id: 'hs-update-form.academic-data.school-type.BRUNEI_DARUSSALAM',
    defaultMessage: 'Brunei Darussalam',
  },
  BULGARIA: {
    id: 'hs-update-form.academic-data.school-type.BULGARIA',
    defaultMessage: 'Bulgaria',
  },
  BURKINA_FASO: {
    id: 'hs-update-form.academic-data.school-type.BURKINA_FASO',
    defaultMessage: 'Burkina Faso',
  },
  BURUNDI: {
    id: 'hs-update-form.academic-data.school-type.BURUNDI',
    defaultMessage: 'Burundi',
  },
  CAMBODIA: {
    id: 'hs-update-form.academic-data.school-type.CAMBODIA',
    defaultMessage: 'Cambodia',
  },
  CAMEROON: {
    id: 'hs-update-form.academic-data.school-type.CAMEROON',
    defaultMessage: 'Cameroon',
  },
  CANADA: {
    id: 'hs-update-form.academic-data.school-type.CANADA',
    defaultMessage: 'Canada',
  },
  CAPE_VERDE: {
    id: 'hs-update-form.academic-data.school-type.CAPE_VERDE',
    defaultMessage: 'Cape Verde',
  },
  CAYMAN_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.CAYMAN_ISLANDS',
    defaultMessage: 'Cayman Islands',
  },
  CENTRAL_AFRICAN_REPUBLIC: {
    id: 'hs-update-form.academic-data.school-type.CENTRAL_AFRICAN_REPUBLIC',
    defaultMessage: 'Central African Republic',
  },
  CHAD: {
    id: 'hs-update-form.academic-data.school-type.CHAD',
    defaultMessage: 'Chad',
  },
  CHILE: {
    id: 'hs-update-form.academic-data.school-type.CHILE',
    defaultMessage: 'Chile',
  },
  CHINA: {
    id: 'hs-update-form.academic-data.school-type.CHINA',
    defaultMessage: 'China',
  },
  CHRISTMAS_ISLAND: {
    id: 'hs-update-form.academic-data.school-type.CHRISTMAS_ISLAND',
    defaultMessage: 'Christmas Island',
  },
  COCOS_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.COCOS_ISLANDS',
    defaultMessage: 'Cocos (Keeling) Islands',
  },
  COLOMBIA: {
    id: 'hs-update-form.academic-data.school-type.COLOMBIA',
    defaultMessage: 'Colombia',
  },
  COMOROS: {
    id: 'hs-update-form.academic-data.school-type.COMOROS',
    defaultMessage: 'Comoros',
  },
  CONGO: {
    id: 'hs-update-form.academic-data.school-type.CONGO',
    defaultMessage: 'Congo',
  },
  THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO: {
    id: 'hs-update-form.academic-data.school-type.THE_DEMOCRATIC_REPUBLIC_OF_THE_CONGO',
    defaultMessage: 'Congo, The Democratic Republic Of The',
  },
  COOK_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.COOK_ISLANDS',
    defaultMessage: 'Cook Islands',
  },
  COSTA_RICA: {
    id: 'hs-update-form.academic-data.school-type.COSTA_RICA',
    defaultMessage: 'Costa Rica',
  },
  COTE_D_IVOIRE: {
    id: 'hs-update-form.academic-data.school-type.COTE_D_IVOIRE',
    defaultMessage: 'Cote D\'ivoire',
  },
  CROATIA: {
    id: 'hs-update-form.academic-data.school-type.CROATIA',
    defaultMessage: 'Croatia',
  },
  CUBA: {
    id: 'hs-update-form.academic-data.school-type.CUBA',
    defaultMessage: 'Cuba',
  },
  CYPRUS: {
    id: 'hs-update-form.academic-data.school-type.CYPRUS',
    defaultMessage: 'Cyprus',
  },
  CZECH_REPUBLIC: {
    id: 'hs-update-form.academic-data.school-type.CZECH_REPUBLIC',
    defaultMessage: 'Czech Republic',
  },
  DENMARK: {
    id: 'hs-update-form.academic-data.school-type.DENMARK',
    defaultMessage: 'Denmark',
  },
  DJIBOUTI: {
    id: 'hs-update-form.academic-data.school-type.DJIBOUTI',
    defaultMessage: 'Djibouti',
  },
  DOMINICA: {
    id: 'hs-update-form.academic-data.school-type.DOMINICA',
    defaultMessage: 'Dominica',
  },
  DOMINICAN_REPUBLIC: {
    id: 'hs-update-form.academic-data.school-type.DOMINICAN_REPUBLIC',
    defaultMessage: 'Dominican Republic',
  },
  EAST_TIMOR: {
    id: 'hs-update-form.academic-data.school-type.EAST_TIMOR',
    defaultMessage: 'East Timor',
  },
  ECUADOR: {
    id: 'hs-update-form.academic-data.school-type.ECUADOR',
    defaultMessage: 'Ecuador',
  },
  EGYPT: {
    id: 'hs-update-form.academic-data.school-type.EGYPT',
    defaultMessage: 'Egypt',
  },
  EL_SALVADOR: {
    id: 'hs-update-form.academic-data.school-type.EL_SALVADOR',
    defaultMessage: 'El Salvador',
  },
  EQUATORIAL_GUINEA: {
    id: 'hs-update-form.academic-data.school-type.EQUATORIAL_GUINEA',
    defaultMessage: 'Equatorial Guinea',
  },
  ERITREA: {
    id: 'hs-update-form.academic-data.school-type.ERITREA',
    defaultMessage: 'Eritrea',
  },
  ESTONIA: {
    id: 'hs-update-form.academic-data.school-type.ESTONIA',
    defaultMessage: 'Estonia',
  },
  ETHIOPIA: {
    id: 'hs-update-form.academic-data.school-type.ETHIOPIA',
    defaultMessage: 'Ethiopia',
  },
  FALKLAND_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.FALKLAND_ISLANDS',
    defaultMessage: 'Falkland Islands (Malvinas)',
  },
  FAROE_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.FAROE_ISLANDS',
    defaultMessage: 'Faroe Islands',
  },
  FIJI: {
    id: 'hs-update-form.academic-data.school-type.FIJI',
    defaultMessage: 'Fiji',
  },
  FINLAND: {
    id: 'hs-update-form.academic-data.school-type.FINLAND',
    defaultMessage: 'Finland',
  },
  FRANCE: {
    id: 'hs-update-form.academic-data.school-type.FRANCE',
    defaultMessage: 'France',
  },
  FRENCH_GUIANA: {
    id: 'hs-update-form.academic-data.school-type.FRENCH_GUIANA',
    defaultMessage: 'French Guiana',
  },
  FRENCH_POLYNESIA: {
    id: 'hs-update-form.academic-data.school-type.FRENCH_POLYNESIA',
    defaultMessage: 'French Polynesia',
  },
  FRENCH_SOUTHERN_TERRITORIES: {
    id: 'hs-update-form.academic-data.school-type.FRENCH_SOUTHERN_TERRITORIES',
    defaultMessage: 'French Southern Territories',
  },
  GABON: {
    id: 'hs-update-form.academic-data.school-type.GABON',
    defaultMessage: 'Gabon',
  },
  GAMBIA: {
    id: 'hs-update-form.academic-data.school-type.GAMBIA',
    defaultMessage: 'Gambia',
  },
  GEORGIA: {
    id: 'hs-update-form.academic-data.school-type.GEORGIA',
    defaultMessage: 'Georgia',
  },
  GERMANY: {
    id: 'hs-update-form.academic-data.school-type.GERMANY',
    defaultMessage: 'Germany',
  },
  GHANA: {
    id: 'hs-update-form.academic-data.school-type.GHANA',
    defaultMessage: 'Ghana',
  },
  GIBRALTAR: {
    id: 'hs-update-form.academic-data.school-type.GIBRALTAR',
    defaultMessage: 'Gibraltar',
  },
  GREECE: {
    id: 'hs-update-form.academic-data.school-type.GREECE',
    defaultMessage: 'Greece',
  },
  GREENLAND: {
    id: 'hs-update-form.academic-data.school-type.GREENLAND',
    defaultMessage: 'Greenland',
  },
  GRENADA: {
    id: 'hs-update-form.academic-data.school-type.GRENADA',
    defaultMessage: 'Grenada',
  },
  GUADELOUPE: {
    id: 'hs-update-form.academic-data.school-type.GUADELOUPE',
    defaultMessage: 'Guadeloupe',
  },
  GUAM: {
    id: 'hs-update-form.academic-data.school-type.GUAM',
    defaultMessage: 'Guam',
  },
  GUATEMALA: {
    id: 'hs-update-form.academic-data.school-type.GUATEMALA',
    defaultMessage: 'Guatemala',
  },
  GUERNSEY: {
    id: 'hs-update-form.academic-data.school-type.GUERNSEY',
    defaultMessage: 'Guernsey',
  },
  GUINEA: {
    id: 'hs-update-form.academic-data.school-type.GUINEA',
    defaultMessage: 'Guinea',
  },
  GUINEA_BISSAU: {
    id: 'hs-update-form.academic-data.school-type.GUINEA_BISSAU',
    defaultMessage: 'Guinea-Bissau',
  },
  GUYANA: {
    id: 'hs-update-form.academic-data.school-type.GUYANA',
    defaultMessage: 'Guyana',
  },
  HAITI: {
    id: 'hs-update-form.academic-data.school-type.HAITI',
    defaultMessage: 'Haiti',
  },
  HEARD_ISLAND_AND_MCDONALD_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.HEARD_ISLAND_AND_MCDONALD_ISLANDS',
    defaultMessage: 'Heard Island And Mcdonald Islands',
  },
  HOLY_SEE: {
    id: 'hs-update-form.academic-data.school-type.HOLY_SEE',
    defaultMessage: 'Holy See (Vatican City State)',
  },
  HONDURAS: {
    id: 'hs-update-form.academic-data.school-type.HONDURAS',
    defaultMessage: 'Honduras',
  },
  HONG_KONG: {
    id: 'hs-update-form.academic-data.school-type.HONG_KONG',
    defaultMessage: 'Hong Kong',
  },
  HUNGARY: {
    id: 'hs-update-form.academic-data.school-type.HUNGARY',
    defaultMessage: 'Hungary',
  },
  ICELAND: {
    id: 'hs-update-form.academic-data.school-type.ICELAND',
    defaultMessage: 'Iceland',
  },
  INDIA: {
    id: 'hs-update-form.academic-data.school-type.INDIA',
    defaultMessage: 'India',
  },
  INDONESIA: {
    id: 'hs-update-form.academic-data.school-type.INDONESIA',
    defaultMessage: 'Indonesia',
  },
  ISLAMIC_REPUBLIC_OF_IRAN: {
    id: 'hs-update-form.academic-data.school-type.ISLAMIC_REPUBLIC_OF_IRAN',
    defaultMessage: 'Iran, Islamic Republic Of',
  },
  IRAQ: {
    id: 'hs-update-form.academic-data.school-type.IRAQ',
    defaultMessage: 'Iraq',
  },
  IRELAND: {
    id: 'hs-update-form.academic-data.school-type.IRELAND',
    defaultMessage: 'Ireland',
  },
  ISLE_OF_MAN: {
    id: 'hs-update-form.academic-data.school-type.ISLE_OF_MAN',
    defaultMessage: 'Isle Of Man',
  },
  ISRAEL: {
    id: 'hs-update-form.academic-data.school-type.ISRAEL',
    defaultMessage: 'Israel',
  },
  ITALY: {
    id: 'hs-update-form.academic-data.school-type.ITALY',
    defaultMessage: 'Italy',
  },
  JAMAICA: {
    id: 'hs-update-form.academic-data.school-type.JAMAICA',
    defaultMessage: 'Jamaica',
  },
  JAPAN: {
    id: 'hs-update-form.academic-data.school-type.JAPAN',
    defaultMessage: 'Japan',
  },
  JERSEY: {
    id: 'hs-update-form.academic-data.school-type.JERSEY',
    defaultMessage: 'Jersey',
  },
  JORDAN: {
    id: 'hs-update-form.academic-data.school-type.JORDAN',
    defaultMessage: 'Jordan',
  },
  KAZAKHSTAN: {
    id: 'hs-update-form.academic-data.school-type.KAZAKHSTAN',
    defaultMessage: 'Kazakhstan',
  },
  KENYA: {
    id: 'hs-update-form.academic-data.school-type.KENYA',
    defaultMessage: 'Kenya',
  },
  KIRIBATI: {
    id: 'hs-update-form.academic-data.school-type.KIRIBATI',
    defaultMessage: 'Kiribati',
  },
  DEMOCRATIC_PEOPLES_REPUBLIC_OF_KOREA: {
    id: 'hs-update-form.academic-data.school-type.DEMOCRATIC_PEOPLES_REPUBLIC_OF_KOREA',
    defaultMessage: 'Korea, Democratic People\'s Republic Of',
  },
  REPUBLIC_OF_KOREA: {
    id: 'hs-update-form.academic-data.school-type.REPUBLIC_OF_KOREA',
    defaultMessage: 'Korea, Republic Of',
  },
  KOSOVO: {
    id: 'hs-update-form.academic-data.school-type.KOSOVO',
    defaultMessage: 'Kosovo',
  },
  KUWAIT: {
    id: 'hs-update-form.academic-data.school-type.KUWAIT',
    defaultMessage: 'Kuwait',
  },
  KYRGYZSTAN: {
    id: 'hs-update-form.academic-data.school-type.KYRGYZSTAN',
    defaultMessage: 'Kyrgyzstan',
  },
  LAO_PEOPLES_DEMOCRATIC_REPUBLIC: {
    id: 'hs-update-form.academic-data.school-type.LAO_PEOPLES_DEMOCRATIC_REPUBLIC',
    defaultMessage: 'Lao People\'s Democratic Republic',
  },
  LATVIA: {
    id: 'hs-update-form.academic-data.school-type.LATVIA',
    defaultMessage: 'Latvia',
  },
  LEBANON: {
    id: 'hs-update-form.academic-data.school-type.LEBANON',
    defaultMessage: 'Lebanon',
  },
  LESOTHO: {
    id: 'hs-update-form.academic-data.school-type.LESOTHO',
    defaultMessage: 'Lesotho',
  },
  LIBERIA: {
    id: 'hs-update-form.academic-data.school-type.LIBERIA',
    defaultMessage: 'Liberia',
  },
  LIBYAN_ARAB_JAMAHIRIYA: {
    id: 'hs-update-form.academic-data.school-type.LIBYAN_ARAB_JAMAHIRIYA',
    defaultMessage: 'Libyan Arab Jamahiriya',
  },
  LIECHTENSTEIN: {
    id: 'hs-update-form.academic-data.school-type.LIECHTENSTEIN',
    defaultMessage: 'Liechtenstein',
  },
  LITHUANIA: {
    id: 'hs-update-form.academic-data.school-type.LITHUANIA',
    defaultMessage: 'Lithuania',
  },
  LUXEMBOURG: {
    id: 'hs-update-form.academic-data.school-type.LUXEMBOURG',
    defaultMessage: 'Luxembourg',
  },
  MACAO: {
    id: 'hs-update-form.academic-data.school-type.MACAO',
    defaultMessage: 'Macao',
  },
  THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA: {
    id: 'hs-update-form.academic-data.school-type.THE_FORMER_YUGOSLAV_REPUBLIC_OF_MACEDONIA',
    defaultMessage: 'Macedonia, The Former Yugoslav Republic Of',
  },
  MADAGASCAR: {
    id: 'hs-update-form.academic-data.school-type.MADAGASCAR',
    defaultMessage: 'Madagascar',
  },
  MALAWI: {
    id: 'hs-update-form.academic-data.school-type.MALAWI',
    defaultMessage: 'Malawi',
  },
  MALAYSIA: {
    id: 'hs-update-form.academic-data.school-type.MALAYSIA',
    defaultMessage: 'Malaysia',
  },
  MALDIVES: {
    id: 'hs-update-form.academic-data.school-type.MALDIVES',
    defaultMessage: 'Maldives',
  },
  MALI: {
    id: 'hs-update-form.academic-data.school-type.MALI',
    defaultMessage: 'Mali',
  },
  MALTA: {
    id: 'hs-update-form.academic-data.school-type.MALTA',
    defaultMessage: 'Malta',
  },
  MARSHALL_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.MARSHALL_ISLANDS',
    defaultMessage: 'Marshall Islands',
  },
  MARTINIQUE: {
    id: 'hs-update-form.academic-data.school-type.MARTINIQUE',
    defaultMessage: 'Martinique',
  },
  MAURITANIA: {
    id: 'hs-update-form.academic-data.school-type.MAURITANIA',
    defaultMessage: 'Mauritania',
  },
  MAURITIUS: {
    id: 'hs-update-form.academic-data.school-type.MAURITIUS',
    defaultMessage: 'Mauritius',
  },
  MAYOTTE: {
    id: 'hs-update-form.academic-data.school-type.MAYOTTE',
    defaultMessage: 'Mayotte',
  },
  MEXICO: {
    id: 'hs-update-form.academic-data.school-type.MEXICO',
    defaultMessage: 'Mexico',
  },
  FEDERATED_STATES_OF_MICRONESIA: {
    id: 'hs-update-form.academic-data.school-type.FEDERATED_STATES_OF_MICRONESIA',
    defaultMessage: 'Micronesia, Federated States Of',
  },
  REPUBLIC_OF_MOLDOVA: {
    id: 'hs-update-form.academic-data.school-type.REPUBLIC_OF_MOLDOVA',
    defaultMessage: 'Moldova, Republic Of',
  },
  MONACO: {
    id: 'hs-update-form.academic-data.school-type.MONACO',
    defaultMessage: 'Monaco',
  },
  MONGOLIA: {
    id: 'hs-update-form.academic-data.school-type.MONGOLIA',
    defaultMessage: 'Mongolia',
  },
  MONTENEGRO: {
    id: 'hs-update-form.academic-data.school-type.MONTENEGRO',
    defaultMessage: 'Montenegro',
  },
  MONTSERRAT: {
    id: 'hs-update-form.academic-data.school-type.MONTSERRAT',
    defaultMessage: 'Montserrat',
  },
  MOROCCO: {
    id: 'hs-update-form.academic-data.school-type.MOROCCO',
    defaultMessage: 'Morocco',
  },
  MOZAMBIQUE: {
    id: 'hs-update-form.academic-data.school-type.MOZAMBIQUE',
    defaultMessage: 'Mozambique',
  },
  MYANMAR: {
    id: 'hs-update-form.academic-data.school-type.MYANMAR',
    defaultMessage: 'Myanmar',
  },
  NAMIBIA: {
    id: 'hs-update-form.academic-data.school-type.NAMIBIA',
    defaultMessage: 'Namibia',
  },
  NAURU: {
    id: 'hs-update-form.academic-data.school-type.NAURU',
    defaultMessage: 'Nauru',
  },
  NEPAL: {
    id: 'hs-update-form.academic-data.school-type.NEPAL',
    defaultMessage: 'Nepal',
  },
  NETHERLANDS: {
    id: 'hs-update-form.academic-data.school-type.NETHERLANDS',
    defaultMessage: 'Netherlands',
  },
  NETHERLANDS_ANTILLES: {
    id: 'hs-update-form.academic-data.school-type.NETHERLANDS_ANTILLES',
    defaultMessage: 'Netherlands Antilles',
  },
  NEW_CALEDONIA: {
    id: 'hs-update-form.academic-data.school-type.NEW_CALEDONIA',
    defaultMessage: 'New Caledonia',
  },
  NEW_ZEALAND: {
    id: 'hs-update-form.academic-data.school-type.NEW_ZEALAND',
    defaultMessage: 'New Zealand',
  },
  NICARAGUA: {
    id: 'hs-update-form.academic-data.school-type.NICARAGUA',
    defaultMessage: 'Nicaragua',
  },
  NIGER: {
    id: 'hs-update-form.academic-data.school-type.NIGER',
    defaultMessage: 'Niger',
  },
  NIGERIA: {
    id: 'hs-update-form.academic-data.school-type.NIGERIA',
    defaultMessage: 'Nigeria',
  },
  NIUE: {
    id: 'hs-update-form.academic-data.school-type.NIUE',
    defaultMessage: 'Niue',
  },
  NORFOLK_ISLAND: {
    id: 'hs-update-form.academic-data.school-type.NORFOLK_ISLAND',
    defaultMessage: 'Norfolk Island',
  },
  NORTHERN_MARIANA_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.NORTHERN_MARIANA_ISLANDS',
    defaultMessage: 'Northern Mariana Islands',
  },
  NORWAY: {
    id: 'hs-update-form.academic-data.school-type.NORWAY',
    defaultMessage: 'Norway',
  },
  OMAN: {
    id: 'hs-update-form.academic-data.school-type.OMAN',
    defaultMessage: 'Oman',
  },
  PAKISTAN: {
    id: 'hs-update-form.academic-data.school-type.PAKISTAN',
    defaultMessage: 'Pakistan',
  },
  PALAU: {
    id: 'hs-update-form.academic-data.school-type.PALAU',
    defaultMessage: 'Palau',
  },
  OCCUPIED_PALESTINIAN_TERRITORY: {
    id: 'hs-update-form.academic-data.school-type.OCCUPIED_PALESTINIAN_TERRITORY',
    defaultMessage: 'Palestinian Territory, Occupied',
  },
  PANAMA: {
    id: 'hs-update-form.academic-data.school-type.PANAMA',
    defaultMessage: 'Panama',
  },
  PAPUA_NEW_GUINEA: {
    id: 'hs-update-form.academic-data.school-type.PAPUA_NEW_GUINEA',
    defaultMessage: 'Papua New Guinea',
  },
  PARAGUAY: {
    id: 'hs-update-form.academic-data.school-type.PARAGUAY',
    defaultMessage: 'Paraguay',
  },
  PERU: {
    id: 'hs-update-form.academic-data.school-type.PERU',
    defaultMessage: 'Peru',
  },
  PHILIPPINES: {
    id: 'hs-update-form.academic-data.school-type.PHILIPPINES',
    defaultMessage: 'Philippines',
  },
  PITCAIRN: {
    id: 'hs-update-form.academic-data.school-type.PITCAIRN',
    defaultMessage: 'Pitcairn',
  },
  POLAND: {
    id: 'hs-update-form.academic-data.school-type.POLAND',
    defaultMessage: 'Poland',
  },
  PORTUGAL: {
    id: 'hs-update-form.academic-data.school-type.PORTUGAL',
    defaultMessage: 'Portugal',
  },
  PUERTO_RICO: {
    id: 'hs-update-form.academic-data.school-type.PUERTO_RICO',
    defaultMessage: 'Puerto Rico',
  },
  QATAR: {
    id: 'hs-update-form.academic-data.school-type.QATAR',
    defaultMessage: 'Qatar',
  },
  REUNION: {
    id: 'hs-update-form.academic-data.school-type.REUNION',
    defaultMessage: 'Reunion',
  },
  ROMANIA: {
    id: 'hs-update-form.academic-data.school-type.ROMANIA',
    defaultMessage: 'Romania',
  },
  RUSSIAN_FEDERATION: {
    id: 'hs-update-form.academic-data.school-type.RUSSIAN_FEDERATION',
    defaultMessage: 'Russian Federation',
  },
  RWANDA: {
    id: 'hs-update-form.academic-data.school-type.RWANDA',
    defaultMessage: 'Rwanda',
  },
  SAINT_HELENA: {
    id: 'hs-update-form.academic-data.school-type.SAINT_HELENA',
    defaultMessage: 'Saint Helena',
  },
  SAINT_KITTS_AND_NEVIS: {
    id: 'hs-update-form.academic-data.school-type.SAINT_KITTS_AND_NEVIS',
    defaultMessage: 'Saint Kitts And Nevis',
  },
  SAINT_LUCIA: {
    id: 'hs-update-form.academic-data.school-type.SAINT_LUCIA',
    defaultMessage: 'Saint Lucia',
  },
  SAINT_PIERRE_AND_MIQUELON: {
    id: 'hs-update-form.academic-data.school-type.SAINT_PIERRE_AND_MIQUELON',
    defaultMessage: 'Saint Pierre And Miquelon',
  },
  SAINT_VINCENT_AND_THE_GRENADINES: {
    id: 'hs-update-form.academic-data.school-type.SAINT_VINCENT_AND_THE_GRENADINES',
    defaultMessage: 'Saint Vincent And The Grenadines',
  },
  SAMOA: {
    id: 'hs-update-form.academic-data.school-type.SAMOA',
    defaultMessage: 'Samoa',
  },
  SAN_MARINO: {
    id: 'hs-update-form.academic-data.school-type.SAN_MARINO',
    defaultMessage: 'San Marino',
  },
  SAO_TOME_AND_PRINCIPE: {
    id: 'hs-update-form.academic-data.school-type.SAO_TOME_AND_PRINCIPE',
    defaultMessage: 'Sao Tome And Principe',
  },
  SAUDI_ARABIA: {
    id: 'hs-update-form.academic-data.school-type.SAUDI_ARABIA',
    defaultMessage: 'Saudi Arabia',
  },
  SENEGAL: {
    id: 'hs-update-form.academic-data.school-type.SENEGAL',
    defaultMessage: 'Senegal',
  },
  SERBIA: {
    id: 'hs-update-form.academic-data.school-type.SERBIA',
    defaultMessage: 'Serbia',
  },
  SEYCHELLES: {
    id: 'hs-update-form.academic-data.school-type.SEYCHELLES',
    defaultMessage: 'Seychelles',
  },
  SIERRA_LEONE: {
    id: 'hs-update-form.academic-data.school-type.SIERRA_LEONE',
    defaultMessage: 'Sierra Leone',
  },
  SINGAPORE: {
    id: 'hs-update-form.academic-data.school-type.SINGAPORE',
    defaultMessage: 'Singapore',
  },
  SLOVAKIA: {
    id: 'hs-update-form.academic-data.school-type.SLOVAKIA',
    defaultMessage: 'Slovakia',
  },
  SLOVENIA: {
    id: 'hs-update-form.academic-data.school-type.SLOVENIA',
    defaultMessage: 'Slovenia',
  },
  SOLOMON_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.SOLOMON_ISLANDS',
    defaultMessage: 'Solomon Islands',
  },
  SOMALIA: {
    id: 'hs-update-form.academic-data.school-type.SOMALIA',
    defaultMessage: 'Somalia',
  },
  SOUTH_AFRICA: {
    id: 'hs-update-form.academic-data.school-type.SOUTH_AFRICA',
    defaultMessage: 'South Africa',
  },
  SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.SOUTH_GEORGIA_AND_THE_SOUTH_SANDWICH_ISLANDS',
    defaultMessage: 'South Georgia And The South Sandwich Islands',
  },
  SPAIN: {
    id: 'hs-update-form.academic-data.school-type.SPAIN',
    defaultMessage: 'Spain',
  },
  SRI_LANKA: {
    id: 'hs-update-form.academic-data.school-type.SRI_LANKA',
    defaultMessage: 'Sri Lanka',
  },
  SUDAN: {
    id: 'hs-update-form.academic-data.school-type.SUDAN',
    defaultMessage: 'Sudan',
  },
  SURINAME: {
    id: 'hs-update-form.academic-data.school-type.SURINAME',
    defaultMessage: 'Suriname',
  },
  SVALBARD_AND_JAN_MAYEN: {
    id: 'hs-update-form.academic-data.school-type.SVALBARD_AND_JAN_MAYEN',
    defaultMessage: 'Svalbard And Jan Mayen',
  },
  SWAZILAND: {
    id: 'hs-update-form.academic-data.school-type.SWAZILAND',
    defaultMessage: 'Swaziland',
  },
  SWEDEN: {
    id: 'hs-update-form.academic-data.school-type.SWEDEN',
    defaultMessage: 'Sweden',
  },
  SWITZERLAND: {
    id: 'hs-update-form.academic-data.school-type.SWITZERLAND',
    defaultMessage: 'Switzerland',
  },
  SYRIAN_ARAB_REPUBLIC: {
    id: 'hs-update-form.academic-data.school-type.SYRIAN_ARAB_REPUBLIC',
    defaultMessage: 'Syrian Arab Republic',
  },
  TAIWAN_PROVINCE_OF_CHINA: {
    id: 'hs-update-form.academic-data.school-type.TAIWAN_PROVINCE_OF_CHINA',
    defaultMessage: 'Taiwan, Province Of China',
  },
  TAJIKISTAN: {
    id: 'hs-update-form.academic-data.school-type.TAJIKISTAN',
    defaultMessage: 'Tajikistan',
  },
  UNITED_REPUBLIC_OF_TANZANIA: {
    id: 'hs-update-form.academic-data.school-type.UNITED_REPUBLIC_OF_TANZANIA',
    defaultMessage: 'Tanzania, United Republic Of',
  },
  THAILAND: {
    id: 'hs-update-form.academic-data.school-type.THAILAND',
    defaultMessage: 'Thailand',
  },
  TIMOR_LESTE: {
    id: 'hs-update-form.academic-data.school-type.TIMOR_LESTE',
    defaultMessage: 'Timor-Leste',
  },
  TOGO: {
    id: 'hs-update-form.academic-data.school-type.TOGO',
    defaultMessage: 'Togo',
  },
  TOKELAU: {
    id: 'hs-update-form.academic-data.school-type.TOKELAU',
    defaultMessage: 'Tokelau',
  },
  TONGA: {
    id: 'hs-update-form.academic-data.school-type.TONGA',
    defaultMessage: 'Tonga',
  },
  TRINIDAD_AND_TOBAGO: {
    id: 'hs-update-form.academic-data.school-type.TRINIDAD_AND_TOBAGO',
    defaultMessage: 'Trinidad And Tobago',
  },
  TUNISIA: {
    id: 'hs-update-form.academic-data.school-type.TUNISIA',
    defaultMessage: 'Tunisia',
  },
  TURKEY: {
    id: 'hs-update-form.academic-data.school-type.TURKEY',
    defaultMessage: 'Turkey',
  },
  TURKMENISTAN: {
    id: 'hs-update-form.academic-data.school-type.TURKMENISTAN',
    defaultMessage: 'Turkmenistan',
  },
  TURKS_AND_CAICOS_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.TURKS_AND_CAICOS_ISLANDS',
    defaultMessage: 'Turks And Caicos Islands',
  },
  TUVALU: {
    id: 'hs-update-form.academic-data.school-type.TUVALU',
    defaultMessage: 'Tuvalu',
  },
  UGANDA: {
    id: 'hs-update-form.academic-data.school-type.UGANDA',
    defaultMessage: 'Uganda',
  },
  UKRAINE: {
    id: 'hs-update-form.academic-data.school-type.UKRAINE',
    defaultMessage: 'Ukraine',
  },
  UNITED_ARAB_EMIRATES: {
    id: 'hs-update-form.academic-data.school-type.UNITED_ARAB_EMIRATES',
    defaultMessage: 'United Arab Emirates',
  },
  UNITED_KINGDOM: {
    id: 'hs-update-form.academic-data.school-type.UNITED_KINGDOM',
    defaultMessage: 'United Kingdom',
  },
  UNITED_STATES: {
    id: 'hs-update-form.academic-data.school-type.UNITED_STATES',
    defaultMessage: 'United States',
  },
  UNITED_STATES_MINOR_OUTLYING_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.UNITED_STATES_MINOR_OUTLYING_ISLANDS',
    defaultMessage: 'United States Minor Outlying Islands',
  },
  URUGUAY: {
    id: 'hs-update-form.academic-data.school-type.URUGUAY',
    defaultMessage: 'Uruguay',
  },
  UZBEKISTAN: {
    id: 'hs-update-form.academic-data.school-type.UZBEKISTAN',
    defaultMessage: 'Uzbekistan',
  },
  VANUATU: {
    id: 'hs-update-form.academic-data.school-type.VANUATU',
    defaultMessage: 'Vanuatu',
  },
  VENEZUELA: {
    id: 'hs-update-form.academic-data.school-type.VENEZUELA',
    defaultMessage: 'Venezuela',
  },
  VIETNAM: {
    id: 'hs-update-form.academic-data.school-type.VIETNAM',
    defaultMessage: 'Vietnam',
  },
  BRITISH_VIRGIN_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.BRITISH_VIRGIN_ISLANDS',
    defaultMessage: 'Virgin Islands, British',
  },
  US_VIRGIN_ISLANDS: {
    id: 'hs-update-form.academic-data.school-type.US_VIRGIN_ISLANDS',
    defaultMessage: 'Virgin Islands, U.S.',
  },
  WALLIS_AND_FUTUNA: {
    id: 'hs-update-form.academic-data.school-type.WALLIS_AND_FUTUNA',
    defaultMessage: 'Wallis And Futuna',
  },
  WESTERN_SAHARA: {
    id: 'hs-update-form.academic-data.school-type.WESTERN_SAHARA',
    defaultMessage: 'Western Sahara',
  },
  YEMEN: {
    id: 'hs-update-form.academic-data.school-type.YEMEN',
    defaultMessage: 'Yemen',
  },
  ZAMBIA: {
    id: 'hs-update-form.academic-data.school-type.ZAMBIA',
    defaultMessage: 'Zambia',
  },
  ZIMBABWE: {
    id: 'hs-update-form.academic-data.school-type.ZIMBABWE',
    defaultMessage: 'Zimbabwe',
  },
});

export default messages;
